import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Row, Col, Card, CardBody } from 'reactstrap';

import { ColorArea } from '../../../../Leads/assets/styleds';
import { chartExample6 } from 'variables/charts.js';
import CountUp from 'react-countup';
import { formatCurrency } from 'utils/fuctions/formatCurrency';

const GraphicsProductsMostSoldByPriceCatalog = ({
  filteredLabels,
  filteredData,
  filteredColors,
  count,
  productsData
}) => {
  const totalSubtotal =
    productsData?.reduce(
      (acc, item) => acc + parseFloat(item.subtotal || 0),
      0
    ) || 0;

  return (
    <Row>
      <Col md="4" style={{ alignSelf: 'center' }}>
        <div className="chart">
          <Pie
            data={{
              labels: [...filteredLabels],
              datasets: [
                {
                  data: [...filteredData],
                  backgroundColor: [...filteredColors]
                }
              ]
            }}
            options={chartExample6.options}
            className="chart-canvas"
            id="chart-doughnut"
          />
        </div>
      </Col>

      <Col md="8">
        <Row>
          <Col md="6">
            <h1 className="display-1">
              <CountUp end={count} />
            </h1>
            <h2 className="text-muted font-weight-light mt--3">
              Total de Produtos
            </h2>
          </Col>
          <Col md="6">
            <h1 className="display-1">
              {formatCurrency(totalSubtotal, false)}
            </h1>
            <h2 className="text-muted font-weight-light mt--3">Valor Total</h2>
          </Col>
        </Row>

        <hr />

        <Row className="mr-0">
          {productsData &&
            productsData.map((product, index) => {
              const percentageQuantity = count
                ? parseFloat((100 * product.quantity) / count).toFixed(2)
                : '0';

              const percentageSubtotal = totalSubtotal
                ? parseFloat(
                    (100 * parseFloat(product.subtotal)) / totalSubtotal
                  ).toFixed(2)
                : '0';

              return (
                <Col md="6" key={index} className="mt-2 mb-2">
                  <Card className="shadow-sm">
                    <CardBody>
                      <Row className="align-items-center">
                        <Col md="1">
                          <ColorArea color={filteredColors[index]} />
                        </Col>
                        <Col md="11">
                          <h4>{product.name || '-'}</h4>
                          <Row>
                            <Col md="6">
                              <div className="d-flex align-items-baseline">
                                <h3 className="mb-0 mr-2">
                                  {product.quantity}
                                </h3>
                                <span className="text-muted">unidades</span>
                              </div>
                              <p className="text-muted mb-0">
                                {percentageQuantity}% do total
                              </p>
                            </Col>
                            <Col md="6">
                              <div className="d-flex align-items-baseline">
                                <h3 className="mb-0 mr-2">
                                  {formatCurrency(product.subtotal, false)}
                                </h3>
                              </div>
                              <p className="text-muted mb-0">
                                {percentageSubtotal}% do valor total
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              );
            })}
        </Row>
      </Col>
    </Row>
  );
};

export default GraphicsProductsMostSoldByPriceCatalog;
